import { Component, OnInit } from '@angular/core';
import { PeymentService } from '@api/peyment.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import jalaliMoment = require('jalali-moment');

@Component({
  selector: 'app-verification-bank',
  templateUrl: './verification-bank.component.html',
  styleUrls: ['./verification-bank.component.scss']
})
export class VerificationBankComponent implements OnInit {

  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  public destroy$ = new Subject<void>();
  requestBank: any;

  constructor( private paymentService: PeymentService) { }

  ngOnInit(): void {
    this.paymentService.requestBankAccount(this.startPage ,this.pageSize ).pipe(takeUntil(this.destroy$ )).subscribe(
      (res: any) => {
        this.requestBank = res;
        this.requestBank.reqBanks.forEach((element): any => {
          element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }
    )
  }
  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize
    this.paymentService.requestBankAccount((event.pageIndex) + 1 , this.pageSize).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) => {
        this.requestBank = res;
        this.requestBank.reqBanks.forEach((element): any => {
          element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
  }
    )}
}

